App.prototype.buildSelect = function (data, targetElement) {
    var options = '<option value="">' + translates.choose + '</option>';
    data.options.forEach(function (item) {
        options += '<option value="' + item.unique_id + '">' + item.name + '</option>';
    });
    var required = data.is_required ? ' required' : '';
    var select = '<div class="form-group">' +
        '<label>' + data.name + '</label>' +
        '<select name="features[' + data.unique_id + ']" class="form-control custom-select" ' + required + '>' + options + '</select>' +
        '</div>';
    targetElement.append(select);
    targetElement.find('select').trigger('change');
};
